module.exports = __webpack_public_path__ + "img/top_lightning_mobile.59153565.png";